import useSWR, { SWRConfiguration } from 'swr'
import { learningApi } from 'services/api'
import { toast } from 'react-toastify'

export function useGetInvoiceHistory({ order }: { order?: string }) {
  const token = localStorage.getItem('token')

  const url = `/order/${order || ''}`

  const key = token ? [url, token] : null

  return useSWR(key, fetcher, configuration)
}

const fetcher = ([url, token]: [string, string]) =>
  learningApi
    .get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)

const configuration: SWRConfiguration = {
  fallbackData: { lastConsumedContent: [] },
  shouldRetryOnError: true,
  onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
    if (retryCount > 3) {
      toast.error('Não foi possível carregar as suas ordens. Tente novamente mais tarde.')
    } else {
      setTimeout(() => revalidate({ retryCount }), 1000)
    }
  },
  keepPreviousData: true,
  dedupingInterval: 60e3,
  revalidateOnReconnect: true,
}
